import {Template, Component} from '@scoutgg/ftw/source/lib'
import template from './esports-information.jade'
import '@scoutgg/ftw/source/atoms/icons/icons'
import {EsportsLeague} from '../../models'

@Component('sporty')
@Template(template)
export default class EsportsInformation extends HTMLElement {
  created() {

  }

  attached() {
    this.selectedLeague = null
    EsportsLeague.load().then(leagues => this.render(this.leagues = leagues))
  }

  selectLeague(league) {
    this.selectedLeague = league
    EsportsLeague.load(league.leagueid).then(matches => {
      this.liveMatches = matches
      this.render()
    })
  }

  get matches() {
    return this.livematches ? this.livematches : []
  }
}
